module.exports = __webpack_public_path__ + "static/img/app04.2ec6cde9.png";